import { z } from 'zod'
import { paxtonHighlightAreaSchema } from '@/components/react-pdf-viewer/schema/paxton-highlight-area'

/**
 * Previously ChatV2ReferenceType and ChatV2MessageReferenceType from chat-v2.slice.ts.
 *
 * During legacy chat cleanup, discovered these are only used by the analytics system.
 * Moved to analytics directory and renamed to avoid confusion as ChatV2 references
 * no longer exist (everything is agent now). Didn't want to touch them since we're
 * not sure of the implications on analytics reporting.
 *
 * TODO: Get Carlos to review whether these types are still needed or if we should use
 * more agent-scoped types instead.
 */
export enum AnalyticsReferenceType {
  documentquery = 'documentquery',
  documentquery_full_doc = 'documentquery_full_doc',
  pol = 'pol',
  caselaw = 'caselaw',
  caselaw_v3 = 'caselaw_v3',
  lrr_v2 = 'lrr_v2',
  lrr_v3 = 'lrr_v3',
}

export const AnalyticsReferenceSchema = z.object({
  reference_number: z.string(),
  text: z.string(),
  metadata: z.record(z.any()),
  relevant_sentences: z.array(z.string()).nullable(),
  relevant_highlights: z
    .array(paxtonHighlightAreaSchema)
    .nullable()
    .describe('Highlight bounding box data compatible with react_pdf_viewer highlighting needs and sentence grouping needs'),
})
export type AnalyticsReference = z.infer<typeof AnalyticsReferenceSchema>
